export const TEST_ID = 'toast';

export const ERROR = 'error';
